import clsx from "clsx";
import DatePicker, { DatePickerProps } from "react-datepicker";
import styles from "./GlassDatePicker.module.css";

export type GlassDatePickerProps = DatePickerProps & {
  /** Subtle accent on the input border when a value is set. */
  ready?: boolean;
};

/**
 * Thin wrapper around react-datepicker that applies the glass theme to
 * both the input and the calendar popper. Keeps page-level CSS modules
 * free of the picker's many third-party class overrides.
 *
 * `DatePickerProps` is a discriminated union (the lib uses overloads on
 * `selectsRange` / `selectsMultiple` to refine `onChange`'s payload).
 * The cast keeps that variance instead of pinning to a single variant.
 */
export const GlassDatePicker = ({ ready, className, ...rest }: GlassDatePickerProps) => (
  <DatePicker
    {...(rest as DatePickerProps)}
    className={clsx(styles.input, ready && styles.ready, className)}
  />
);
